import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';

import { Invoice } from 'apps/shared/scripts/__generated__/graphql.generated';
import { Icon } from 'apps/shared/scripts/components';
import { formatCurrency, formatDateYear } from 'apps/shared/scripts/utils';

import { iconClassName, invoiceBannerClassName, textClassName } from './styles';

type Props = Pick<Invoice, 'totals' | 'transactionTimestamp'>;

const InvoiceBanner = ({ totals, transactionTimestamp }: Props) => {
  return (
    <div className={invoiceBannerClassName}>
      <Icon className={iconClassName} fa={faCheckCircle} />
      <span className={textClassName}>
        Paid {formatCurrency(totals.grandTotal)} on{' '}
        {formatDateYear(transactionTimestamp)}
      </span>
    </div>
  );
};

InvoiceBanner.displayName = 'InvoiceBanner';

export default InvoiceBanner;
